import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchPrioritizedAlerts, fetchAnomalyTimeline, fetchThreatPredictions, fetchBehavioralInsights
} from '../../services/api/aiService';

export const loadAiIntelligence = createAsyncThunk('ai/load', async () => {
  const [alerts, timeline, predictions, behavioral] = await Promise.all([
    fetchPrioritizedAlerts(), fetchAnomalyTimeline(), fetchThreatPredictions(), fetchBehavioralInsights()
  ]);
  return { alerts, timeline, predictions, behavioral };
});

const aiSlice = createSlice({
  name: 'ai',
  initialState: { status: 'idle', error: null, alerts: [], timeline: [], predictions: [], behavioral: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadAiIntelligence.pending, (state) => { state.status = 'loading'; })
      .addCase(loadAiIntelligence.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.alerts = action.payload.alerts;
        state.timeline = action.payload.timeline;
        state.predictions = action.payload.predictions;
        state.behavioral = action.payload.behavioral;
      })
      .addCase(loadAiIntelligence.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

export default aiSlice.reducer;
